import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import JitsiMeeting from './JitsiMeeting';
import api from '../../services/api';
import './MeetingRoom.css';

/**
 * MeetingRoom Page
 *
 * Displays a Jitsi meeting with meeting metadata
 */
const MeetingRoom = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [meeting, setMeeting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMeeting = async () => {
      try {
        const response = await api.get(`/meetings/${id}`);
        setMeeting(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch meeting:', err);
        setError('Failed to load meeting. Please check if you have access.');
        setLoading(false);
      }
    };

    if (id) {
      fetchMeeting();
    }
  }, [id]);

  const handleLeaveMeeting = async () => {
    try {
      // Update meeting status to completed
      await api.patch(`/meetings/${id}/status`, { status: 'completed' });
    } catch (err) {
      console.error('Failed to update meeting status:', err);
    }

    // Navigate back to meetings list
    navigate('/meetings');
  };

  if (loading) {
    return (
      <div className="meeting-room-loading">
        <div className="spinner-large"></div>
        <p>Loading meeting...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="meeting-room-error">
        <h2>Meeting Not Found</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/meetings')} className="btn-back">
          Back to Meetings
        </button>
      </div>
    );
  }

  return (
    <div className="meeting-room">
      <JitsiMeeting
        meetingId={meeting.id}
        roomName={meeting.title || `Meeting ${meeting.id}`}
        onLeave={handleLeaveMeeting}
      />
    </div>
  );
};

export default MeetingRoom;
